import React from 'react';
import PropTypes from 'prop-types';
import useLanguage from '../../../../hooks/useLanguage';
import Gradient from '../../../UiComponents/Gradient/Gradient';
import ApproachSlider from '../../../UiComponents/ApproachSlider/ApproachSlider';

const ServicesApproach = ({ approachData }) => {
  const langToggle = useLanguage;
  return (
    <section className="services-approach" data-scroll-section>
      <div className="content-wrapper">
        <header className="services-approach__header">
          <div className="services-approach__marker-wrapper">
            <span className="services-approach__marker">
              {langToggle('Наш підхід', 'Наш подход')}
            </span>
          </div>
          <div className="services-approach__title-wrapper">
            <h2 className="services-approach__title">
              {langToggle(approachData.title_ua, approachData.title_ru)}
            </h2>
          </div>
        </header>
        <ApproachSlider items={approachData.items} />
        <div
          className="services-approach__gradient-wrapper"
          data-scroll=""
          data-scroll-speed="-2.5"
          data-scroll-delay="0.05"
        >
          <div className="services-approach__gradient-wrapper__owerflow">
            <Gradient />
          </div>
        </div>
      </div>
    </section>
  );
};

ServicesApproach.propTypes = {
  approachData: PropTypes.object,
};

export default ServicesApproach;
